import { render } from "./AnimatedInput.vue?vue&type=template&id=5aaa0652&scoped=true"
import script from "./AnimatedInput.vue?vue&type=script&lang=ts"
export * from "./AnimatedInput.vue?vue&type=script&lang=ts"

import "./AnimatedInput.vue?vue&type=style&index=0&id=5aaa0652&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5aaa0652"

export default script